const FLAG_KEY = 'pricing-ab-test';
const FLAGS_TIMEOUT_MS = 3000;

// type PricingCohort = 'a' | 'b';

let currentCohort = 'a';

export function getPricingCohort(){
  return currentCohort;
}

function waitForPosthog(timeoutMs = 5000) {
  return new Promise((resolve) => {
    const start = Date.now();
    const check = () => {
      const ph = window.posthog;
      if (ph && (ph.__loaded || ph.get_distinct_id)) return resolve(ph);
      if (Date.now() - start > timeoutMs) return resolve(null);
      setTimeout(check, 100);
    };
    check();
  });
}

function waitForFeatureFlags(posthog, timeoutMs = FLAGS_TIMEOUT_MS) {
  return new Promise((resolve) => {
    if (!posthog.onFeatureFlags) return resolve();

    let done = false;
    let unsubscribe;
    const timer = setTimeout(finish, timeoutMs);

    function finish() {
      if (done) return;
      done = true;
      clearTimeout(timer);
      unsubscribe?.();
      resolve();
    }

    // fires immediately if flags are already loaded, otherwise once they arrive
    unsubscribe = posthog.onFeatureFlags(finish);
  });
}

export const pricingExperimentReady = initPricingExperiment().catch(() => 'a');

export async function initPricingExperiment() {
  try {
    const posthog = await waitForPosthog();

    if (posthog) {
      await waitForFeatureFlags(posthog);

      const flag = posthog.getFeatureFlag?.(FLAG_KEY);
      currentCohort = flag === 'test' ? 'b' : 'a'
      posthog.setPersonProperties?.({ pricing_cohort: currentCohort });
      window.track('pricing_experiment_assigned', { cohort: currentCohort });
    }
  } catch(e) {
    console.log(e)
  }

  return currentCohort;
}
